import {AceCard} from "./AceCard";
import {CardColor} from "./api/CardColor";
import {CardName} from "./api/CardName";
import {Card} from "./Card";

export class CardFactory {

    public static createCard(cardColor: CardColor, cardName: CardName): Card {
        if (cardName === CardName.ACE) {
            return new AceCard(
                cardColor, cardName, CardFactory.getCardValue(cardName), CardFactory.getAceAlternativeValue());
        }

        return new Card(cardColor, cardName, CardFactory.getCardValue(cardName));
    }

    private static getCardValue(cardName: CardName): number {
        switch (cardName) {
            case(CardName.TWO):
                return 2;
            case(CardName.THREE):
                return 3;
            case(CardName.FOUR):
                return 4;
            case(CardName.FIVE):
                return 5;
            case(CardName.SIX):
                return 6;
            case(CardName.SEVEN):
                return 7;
            case(CardName.EIGHT):
                return 8;
            case(CardName.NINE):
                return 9;
            case(CardName.TEN):
                return 10;
            case(CardName.JACK):
                return 10;
            case(CardName.QUEEN):
                return 10;
            case(CardName.KING):
                return 10;
            case(CardName.ACE):
                return 1;
        }
    }

    private static getAceAlternativeValue(): number {
        return 11;
    }

    private constructor() {
    }
}



// WEBPACK FOOTER //
// ./src/app/CardFactory.ts